import React, { useEffect } from "react";
import { Title } from "../../components/Title";
import { Table, Column } from "../../components/Table";
import Tooltip from "rc-tooltip";
import { useTranslation } from "react-i18next";
import "./styles.less";

const scrollToHash = () => {
  if (!window.location.hash) {
    return;
  }
  const el = document.querySelector(window.location.hash);
  if (el) {
    el.scrollIntoView();
  }
};

export const PriceDetail = () => {
  const { t } = useTranslation();
  const authenticationData = [
    {
      title: `${t("price.compare.authentication.feature1.title")}`,
      tip: `${t("price.compare.authentication.feature1.tip")}`,
      developer: `${t("price.compare.authentication.feature1.list-one")}`,
      developerPro: `${t("price.compare.authentication.feature1.list-two")}`,
      enterprise: `${t("price.compare.authentication.feature1.list-three")}`,
    },
    {
      title: `${t("price.compare.authentication.feature2.title")}`,
      tip: `${t("price.compare.authentication.feature2.tip")}`,
      developer: `${t("price.compare.authentication.feature2.list-one")}`,
      developerPro: `${t("price.compare.authentication.feature2.list-two")}`,
      enterprise: `${t("price.compare.authentication.feature2.list-three")}`,
    },
    {
      title: `${t("price.compare.authentication.feature3.title")}`,
      tip: `${t("price.compare.authentication.feature3.tip")}`,
      developer: `${t("price.compare.authentication.feature3.list-one")}`,
      developerPro: `${t("price.compare.authentication.feature3.list-two")}`,
      enterprise: `${t("price.compare.authentication.feature3.list-three")}`,
    },
    {
      title: `${t("price.compare.authentication.feature4.title")}`,
      tip: `${t("price.compare.authentication.feature4.tip")}`,
      developer: `${t("price.compare.authentication.feature4.list-one")}`,
      developerPro: `${t("price.compare.authentication.feature4.list-two")}`,
      enterprise: `${t("price.compare.authentication.feature4.list-three")}`,
    },
  ];
  const userManageData = [
    {
      title: `${t("price.compare.userManagement.feature1.title")}`,
      tip: `${t("price.compare.userManagement.feature1.tip")}`,
      developer: `${t("price.compare.userManagement.feature1.list-one")}`,
      developerPro: `${t("price.compare.userManagement.feature1.list-two")}`,
      enterprise: `${t("price.compare.userManagement.feature1.list-three")}`,
    },
    {
      title: `${t("price.compare.userManagement.feature2.title")}`,
      tip: `${t("price.compare.userManagement.feature2.tip")}`,
      developer: `${t("price.compare.userManagement.feature2.list-one")}`,
      developerPro: `${t("price.compare.userManagement.feature2.list-two")}`,
      enterprise: `${t("price.compare.userManagement.feature2.list-three")}`,
    },
    {
      title: `${t("price.compare.userManagement.feature3.title")}`,
      tip: `${t("price.compare.userManagement.feature3.tip")}`,
      developer: `${t("price.compare.userManagement.feature3.list-one")}`,
      developerPro: `${t("price.compare.userManagement.feature3.list-two")}`,
      enterprise: `${t("price.compare.userManagement.feature3.list-three")}`,
    },
    {
      title: `${t("price.compare.userManagement.feature4.title")}`,
      tip: `${t("price.compare.userManagement.feature4.tip")}`,
      developer: `${t("price.compare.userManagement.feature4.list-one")}`,
      developerPro: `${t("price.compare.userManagement.feature4.list-two")}`,
      enterprise: `${t("price.compare.userManagement.feature4.list-three")}`,
    },
  ];
  const securityData = [
    {
      title: `${t("price.compare.security.feature1.title")}`,
      tip: `${t("price.compare.security.feature1.tip")}`,
      developer: `${t("price.compare.security.feature1.list-one")}`,
      developerPro: `${t("price.compare.security.feature1.list-two")}`,
      enterprise: `${t("price.compare.security.feature1.list-three")}`,
    },
    {
      title: `${t("price.compare.security.feature2.title")}`,
      tip: `${t("price.compare.security.feature2.tip")}`,
      developer: `${t("price.compare.security.feature2.list-one")}`,
      developerPro: `${t("price.compare.security.feature2.list-two")}`,
      enterprise: `${t("price.compare.security.feature2.list-three")}`,
    },
  ];
  const enterpriseyData = [
    {
      title: `${t("price.compare.enterprisePersonal.feature1.title")}`,
      tip: `${t("price.compare.enterprisePersonal.feature1.tip")}`,
      developer: `${t("price.compare.enterprisePersonal.feature1.list-one")}`,
      developerPro: `${t("price.compare.enterprisePersonal.feature1.list-two")}`,
      enterprise: `${t("price.compare.enterprisePersonal.feature1.list-three")}`,
    },
    {
      title: `${t("price.compare.enterprisePersonal.feature2.title")}`,
      tip: `${t("price.compare.enterprisePersonal.feature2.tip")}`,
      developer: `${t("price.compare.enterprisePersonal.feature2.list-one")}`,
      developerPro: `${t("price.compare.enterprisePersonal.feature2.list-two")}`,
      enterprise: `${t("price.compare.enterprisePersonal.feature2.list-three")}`,
    },
    {
      title: `${t("price.compare.enterprisePersonal.feature3.title")}`,
      tip: `${t("price.compare.enterprisePersonal.feature3.tip")}`,
      developer: `${t("price.compare.enterprisePersonal.feature3.list-one")}`,
      developerPro: `${t("price.compare.enterprisePersonal.feature3.list-two")}`,
      enterprise: `${t("price.compare.enterprisePersonal.feature3.list-three")}`,
    },
    {
      title: `${t("price.compare.enterprisePersonal.feature4.title")}`,
      tip: `${t("price.compare.enterprisePersonal.feature4.tip")}`,
      developer: `${t("price.compare.enterprisePersonal.feature4.list-one")}`,
      developerPro: `${t("price.compare.enterprisePersonal.feature4.list-two")}`,
      enterprise: `${t("price.compare.enterprisePersonal.feature4.list-three")}`,
    },
    {
      title: `${t("price.compare.enterprisePersonal.feature5.title")}`,
      // tip: `${t("price.compare.enterprisePersonal.feature5.tip")}`,
      developer: `${t("price.compare.enterprisePersonal.feature5.list-one")}`,
      developerPro: `${t("price.compare.enterprisePersonal.feature5.list-two")}`,
      enterprise: `${t("price.compare.enterprisePersonal.feature5.list-three")}`,
    },
    {
      title: `${t("price.compare.enterprisePersonal.feature6.title")}`,
      tip: `${t("price.compare.enterprisePersonal.feature6.tip")}`,
      developer: `${t("price.compare.enterprisePersonal.feature6.list-one")}`,
      developerPro: `${t("price.compare.enterprisePersonal.feature6.list-two")}`,
      enterprise: `${t("price.compare.enterprisePersonal.feature6.list-three")}`,
    },
  ];
  const enterpriseySupportData = [
    {
      title: `${t("price.compare.support.feature1.title")}`,
      developer: `${t("price.compare.support.feature1.list-one")}`,
      developerPro: `${t("price.compare.support.feature1.list-two")}`,
      enterprise: `${t("price.compare.support.feature1.list-three")}`,
    },
    {
      title: `${t("price.compare.support.feature2.title")}`,
      developer: `${t("price.compare.support.feature2.list-one")}`,
      developerPro: `${t("price.compare.support.feature2.list-two")}`,
      enterprise: `${t("price.compare.support.feature2.list-three")}`,
    },
    {
      title: `${t("price.compare.support.feature3.title")}`,
      developer: `${t("price.compare.support.feature3.list-one")}`,
      developerPro: `${t("price.compare.support.feature3.list-two")}`,
      enterprise: `${t("price.compare.support.feature3.list-three")}`,
    },
    {
      title: `${t("price.compare.support.feature4.title")}`,
      developer: `${t("price.compare.support.feature4.list-one")}`,
      developerPro: `${t("price.compare.support.feature4.list-two")}`,
      enterprise: `${t("price.compare.support.feature4.list-three")}`,
    },
    {
      title: `${t("price.compare.support.feature5.title")}`,
      developer: `${t("price.compare.support.feature5.list-one")}`,
      developerPro: `${t("price.compare.support.feature5.list-two")}`,
      enterprise: `${t("price.compare.support.feature5.list-three")}`,
    },
    {
      title: `${t("price.compare.support.feature6.title")}`,
      developer: `${t("price.compare.support.feature6.list-one")}`,
      developerPro: `${t("price.compare.support.feature6.list-two")}`,
      enterprise: `${t("price.compare.support.feature6.list-three")}`,
    },
    {
      title: `${t("price.compare.support.feature7.title")}`,
      developer: `${t("price.compare.support.feature7.list-one")}`,
      developerPro: `${t("price.compare.support.feature7.list-two")}`,
      enterprise: `${t("price.compare.support.feature7.list-three")}`,
    },
  ];

  const renderTitle = (value, data) => {
    const tip = <div style={{ maxWidth: 200 }}>{data.tip}</div>;
    return (
      <div className="colum-title" style={{ textAlign: "left", marginLeft: "30px", width: 242 }}>
        <span style={{ marginRight: 6 }}>{value}</span>
        {data.tip && (
          <Tooltip placement="right" mouseLeaveDelay={0.001} trigger={["hover"]} overlay={tip}>
            <i className="icon authing-icon authing-problem" style={{ fontSize: "14px", color: "#bbbbbb" }}></i>
          </Tooltip>
        )}
      </div>
    );
  };

  const renderChecked = (value) => {
    const iconStyl = {
      color: "#cccccc",
      // color: "rgba(57, 106, 255, 0.8)",
    };
    const checkedIcon = <i className="icon authing-icon authing-wancheng" style={iconStyl}></i>;
    return value === "checked" ? checkedIcon : value;
  };

  useEffect(() => {
    window.addEventListener("load", scrollToHash);
    return () => window.removeEventListener("load", scrollToHash);
  });

  return (
    <div className="price-detail" id="price-compare">
      <Title title={t("price.compare.title")}></Title>
      <div className="inner">
        <div className="table-title">
          <span>
            <i className="icon authing-icon authing-developer-fill icon-style"></i>
            {t("price.compare.develop")}
          </span>
          <span>
            <i className="icon authing-icon authing-advanced icon-style"></i>
            {t("price.compare.develop-pro")}
          </span>
          <span>
            <i className="icon authing-icon authing-yiyuan icon-style"></i>
            {t("price.compare.enterprise")}
          </span>
        </div>
      </div>
      <div className="tabel-content">
        <Table data={authenticationData}>
          <Column title={t("price.compare.authentication.title")} dataIndex="title" align="left" render={renderTitle} />
          {/* <Column title="免费版" dataIndex="free" align="left" render={renderChecked} /> */}
          <Column title="" dataIndex="developer" align="left" render={renderChecked} />
          <Column title="" dataIndex="developerPro" align="left" render={renderChecked} />
          <Column title="" dataIndex="enterprise" align="left" render={renderChecked} />
        </Table>
        <Table data={userManageData}>
          <Column title={t("price.compare.userManagement.title")} dataIndex="title" align="left" render={renderTitle} />
          {/* <Column title="免费版" dataIndex="free" align="left" render={renderChecked} /> */}
          <Column title="" dataIndex="developer" align="left" render={renderChecked} />
          <Column title="" dataIndex="developerPro" align="left" render={renderChecked} />
          <Column title="" dataIndex="enterprise" align="left" render={renderChecked} />
        </Table>
        <Table data={securityData}>
          <Column title={t("price.compare.security.title")} dataIndex="title" align="left" render={renderTitle} />
          {/* <Column title="免费版" dataIndex="free" align="left" render={renderChecked} /> */}
          <Column title="" dataIndex="developer" align="left" render={renderChecked} />
          <Column title="" dataIndex="developerPro" align="left" render={renderChecked} />
          <Column title="" dataIndex="enterprise" align="left" render={renderChecked} />
        </Table>
        <Table data={enterpriseyData}>
          <Column
            title={t("price.compare.enterprisePersonal.title")}
            dataIndex="title"
            align="left"
            render={renderTitle}
          />
          {/* <Column title="免费版" dataIndex="free" align="left" render={renderChecked} /> */}
          <Column title="" dataIndex="developer" align="left" render={renderChecked} />
          <Column title="" dataIndex="developerPro" align="left" render={renderChecked} />
          <Column title="" dataIndex="enterprise" align="left" render={renderChecked} />
        </Table>
        <Table data={enterpriseySupportData}>
          <Column title={t("price.compare.support.title")} dataIndex="title" align="left" render={renderTitle} />
          {/* <Column title="免费版" dataIndex="free" align="left" render={renderChecked} /> */}
          <Column title="" dataIndex="developer" align="left" render={renderChecked} />
          <Column title="" dataIndex="developerPro" align="left" render={renderChecked} />
          <Column title="" dataIndex="enterprise" align="left" render={renderChecked} />
        </Table>
      </div>
    </div>
  );
};
